export default {"src":"/_next/static/media/menu.0622d21a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};